import { brandCopy } from '@global-assets/copy';

export const environment = {
  production: true,
  brand_copy: brandCopy,
};
